import { Component, Input, OnInit } from '@angular/core';
import { InputMaskType } from '@rogers/cdk/form';
import { CommonModule } from '@angular/common';
import {
  FormFieldData,
  FormFieldsComponent,
  ReactiveError,
} from '../form-fields/form-fields.component';
import { SafeSend, SafesendInfo } from './safe-send-type';
import { IconModule } from '@rogers/cdk/icon';

@Component({
  standalone: true,
  imports: [CommonModule, FormFieldsComponent, IconModule],
  selector: 'ucx-safe-send-bubble',
  templateUrl: './safe-send-bubble.component.html',
  styleUrls: ['./safe-send-bubble.component.scss'],
})
export class SafeSendBubbleComponent implements OnInit {
  @Input() safeSendTitle = '';
  @Input() safeSendDescription = '';
  @Input() submitText = '';
  @Input() skipText = '';
  @Input() requiredErrorMessage = '';
  @Input() emailErrorMessage = '';
  @Input() safeSend = new SafeSend();
  @Input() creditCardConfig: any;
  @Input() isSubmitted = false;
  @Input() isCancelBtnHidden = false;

  @Input() onUpdateSafeSendStatus;

  formFields: FormFieldData[] = [];

  async ngOnInit(): Promise<void> {
    this.convertSafeSendFormFields();
  }

  async convertSafeSendFormFields(): Promise<void> {
    this.formFields = [];
    if (this.safeSend?.fields) {
      for (const field of this.safeSend.fields as Iterable<any>) {
        const formFieldData: FormFieldData = {
          type: field.type,
          id: field.id,
          name: field.name,
          placeholder: field.placeholder,
          label: field.label,
          value: field.value,
          mask: field.mask ? field.mask : InputMaskType.Custom,
        };
        formFieldData.reactiveErrors = [];
        if (field.required) {
          const reactiveError: ReactiveError = {
            error: 'required',
            message: this.requiredErrorMessage,
          };
          formFieldData.reactiveErrors.push(reactiveError);
        }
        if (field.name == 'email') {
          const reactiveError: ReactiveError = {
            error: 'email',
            message: this.emailErrorMessage,
          };
          formFieldData.reactiveErrors.push(reactiveError);
        }
        this.formFields.push(formFieldData);
      }
    }
  }

  updateSafeSend(isSubmitted: boolean, isDisabled: boolean, formValues?): void {
    const safeSend = JSON.parse(JSON.stringify(this.safeSend));
    safeSend.disabled = isDisabled;
    safeSend.submitRequested = isSubmitted;
    safeSend.formValues = formValues;
    if (safeSend.formValues) {
      const emptyFields: string[] = [];
      Object.entries(safeSend.formValues).forEach(([key, val]) =>
        val ? '' : emptyFields.push(key.toString())
      );
      const safesendInfoArray: SafesendInfo[] = [];
      if (safeSend?.fields) {
        for (const field of safeSend.fields as Iterable<any>) {
          const safesendInfo = new SafesendInfo();
          safesendInfo.question = field.label;
          safesendInfo.answer = safeSend.formValues[field.name.toString()];
          safesendInfo.questionId = field.id;
          safesendInfoArray.push(safesendInfo);
        }
      }
      safeSend.safesendInfoArray = safesendInfoArray;
    }
    this.onUpdateSafeSendStatus(safeSend);
  }

  onSubmit = (event): void => {
    this.updateSafeSend(true, false, event);
  };

  oncancel = (): void => {
    this.updateSafeSend(false, true);
  };
}
